// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"449c5342","232":"d2a504a9","237":"e8af506d","357":"e8ea357c","526":"f6f97962","872":"96748cce"}[chunkId] + ".chunk.js";
};